import { render, staticRenderFns } from "./sbsp-form-file-upload.vue?vue&type=template&id=a9f6f81a&scoped=true&"
import script from "./sbsp-form-file-upload.vue?vue&type=script&lang=js&"
export * from "./sbsp-form-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-form-file-upload.vue?vue&type=style&index=0&id=a9f6f81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f6f81a",
  null
  
)

export default component.exports